<template>
  <div class="pay-box">
    <div class="head">
      <p>充值成功</p>
    </div>
    <p>
      <label>订单编号</label>
      <span>{{ theReques.out_trade_no }}</span>
    </p>
    <p>
      <label>充值金额</label>
      <span>{{ theReques.total_amount }}元</span>
    </p>
    <p>
      <label>充值渠道</label>
      <span>官网充值</span>
    </p>
    <p>
      <label>充值时间</label>
      <span>{{ theReques.timestamp }}</span>
    </p>
    <!-- <router-link class="pay-button" to="/recharge">继续充值</router-link> -->
    <button type="button" class="pay-button" name="button" @click="toRecharge">继续充值</button>
  </div>
</template>
<script>
export default {
  name:'paysuccess',
  data(){
    return{
      theReques:{}
    }
  },
  methods: {
    toRecharge(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      let name = '/recharge';
      if (flag) {
        name = '/mobilrecharge'
      }
      this.$router.push(name);
    }
  },
  created(){
    this.$store.commit('PaySuccess');
  },
  mounted(){
    var url = decodeURIComponent(window.location.search);
    var theReques = {};
    if (url.indexOf("?")!=-1) {
      var str = url.substr(1);
      str = str.split("&");
      for (var i = 0; i < str.length; i++) {
        theReques[str[i].split("=")[0]] = str[i].split("=")[1];
      }
    }
    this.theReques = theReques
  }
}
</script>
<style media="screen" scoped>
  .head{
    color: #13C929;
    height: 111px;
    line-height: 111px;
    border-bottom: 8px solid #F7F7F9;
  }

  .head p{
    background: url("../assets/icon_pay_right_normal.png") no-repeat center right;
    background-size: 22px;
    display: inline-block;
    width: auto;
    padding-right: 30px;
    font-size: 20px;
  }

  .pay-box>p label{
    float: left;
  }

  .pay-box>p span{
    float: right;
  }

  .pay-box>p{
    height: 40px;
    line-height: 40px;
    margin: 0 5%;
    font-size: 14px;
  }

  .pay-button{
    width: 150px;
    height: 42px;
    border-radius: 5px;
    background: #F54F31;
    border:none;
    color: #ffffff;
    font-size: 18px;
    outline: none;
    display: block;
    line-height: 42px;
    margin: 17.6% auto 0;
  }
</style>



// WEBPACK FOOTER //
// src/mobilPage/paysuccess.vue